"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const styled_react_1 = require("./styled-react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const HabitIcon = ({ image, colors, onClick, className, }) => (
// eslint-disable-next-line react/no-unknown-property
(0, core_1.jsx)("div", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.container, className), css: (0, styled_react_1.gradientColor)(colors) },
    (0, core_1.jsx)("button", { className: styles_scss_1.default.button, onClick: onClick, type: "button" },
        (0, core_1.jsx)("img", { src: image, alt: "", className: styles_scss_1.default.image }))));
HabitIcon.defaultProps = {
    className: null
};
exports.default = HabitIcon;
